import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const trash = createPaginatedSlice('trash');

export const trashActions = trash.actions
export const trashSelector = state => state.trash;
export const trashReducer = trash.reducer;
export default trashReducer

export const trashSelectors = trash.LF.selectors